import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const DetailsContext = createContext();

function DetailsContextProvider ({ id, children, ...props }) {
  const [dialog, setDialog] = useState({ isOpen: false });

  const openDialog = useCallback((dialog, payload) => {
    setDialog({ isOpen: true, dialog, payload });
  }, []);

  const closeDialog = useCallback(() => {
    setDialog({ isOpen: false, dialog: null });
  }, []);

  if (useDetailsContext(id).id === id) {
    return children;
  }

  return (
    <DetailsContext.Provider value={{ id, ...dialog, openDialog, closeDialog }} {...props}>
      {children}
    </DetailsContext.Provider>
  );
}

function useDetailsContext (dialog) {
  const context = useContext(DetailsContext);

  const { openDialog, closeDialog, setOpen } = useMemo(() => {
    const openDialog = (payload) => context.openDialog(dialog, payload);
    const closeDialog = () => context.closeDialog();
    const setOpen = (value) => value ? context.openDialog(dialog) : context.closeDialog();
    return { openDialog, closeDialog, setOpen };
  }, [context, dialog]);

  if (context === undefined) {
    return {};
  }

  const isOpen = context.isOpen && context.dialog === dialog;

  try {
    return { openDialog, closeDialog, setOpen, isOpen, payload: isOpen ? context.payload : null, id: context.id };
  } catch (e) {
    console.log(e);
    return {
      openDialog: () => {
      }, closeDialog: () => {
      }
    };
  }
}

DetailsContextProvider.propTypes = {
  children: PropTypes.any,
  id: PropTypes.string
};

export { DetailsContextProvider, useDetailsContext };
